import { BaseAnnotation } from './annotations/BaseAnnotation'
import { Flag } from './flag'

/**
 * Attach additional flags to a BaseAnnotation.
 *
 * @param base - The base that will receive new flags.
 * @param newFlags - The new flags that will be attached.
 * @returns A new BaseAnnotation with additional flags.
 */
export default function attachFlags(
  base: BaseAnnotation,
  newFlags: Flag[],
): BaseAnnotation {
  const attachedFlags = base.flags.value.concat(newFlags)
  return {
    ...base,
    flags: {
      value: attachedFlags,
      description: base.flags.description,
    },
  }
}
